module.exports = __webpack_public_path__ + "static/img/nav_logo.36da2bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav_logo.png
// module id = bptX
// module chunks = 1